import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Footer from "./components/Footer";
import About from "./pages/About";
import Dining from "./pages/Dining";
import Gallary from "./pages/Gallary";
import Contact from "./pages/Contact";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BookNow from "./pages/BookNow";
import Villas from "./pages/Villas";
import Explore from "./pages/Explore";
import Location from "./pages/Location";
import FamilyVilla from "./pages/villas/FamilyVilla";
import SingleRoomVilla from "./pages/villas/SingleRoomVilla";
import Sigiriya from "./pages/explore/Sigiriya";
import PidurangalaRock from "./pages/explore/PidurangalaRock";
import MinneriyaNationalPark from "./pages/explore/MinneriyaNationalPark";
import Ritigala from "./pages/explore/Ritigala";
import HabaranaVillageSafari from "./pages/explore/HabaranaVillageSafari";
import KaudullaNationalPark from "./pages/explore/KaudullaNationalPark";
import HabaranaLake from "./pages/explore/HabaranaLake";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/villas" element={<Villas />} />
        <Route path="/dining" element={<Dining />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/location" element={<Location />} />
        <Route path="/gallery" element={<Gallary />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-condition" element={<TermsAndCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/book-now" element={<BookNow />} />

        {/* villas */}
        <Route path="/villas/family-villa" element={<FamilyVilla />} />
        <Route path="/villas/single-room-villa" element={<SingleRoomVilla />} />

        {/* explore */}
        <Route path="/explore/sigiriya" element={<Sigiriya />} />
        <Route path="/explore/pidurangala-rock" element={<PidurangalaRock />} />
        <Route path="/explore/minneriya-national-park" element={<MinneriyaNationalPark />} />
        <Route path="/explore/ritigala" element={<Ritigala />} />
        <Route path="/explore/habarana-village-safari" element={<HabaranaVillageSafari />} />
        <Route path="/explore/kaudulla-national-park" element={<KaudullaNationalPark />} />
        <Route path="/explore/habarana-lake" element={<HabaranaLake />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
